// App
import { useSelector } from 'react-redux';
import { useBlurbLinks } from 'app/shared/modules/MobileSRP/SeoFooter/useBlurbLinks';
import { useDynamicBlurb } from 'app/shared/modules/MobileSRP/SeoFooter/useDynamicBlurb';
import type { RootReduxState } from 'app/shared/flux/reducers';

export const useDesktopLogic = () => {
  const area = useSelector((state: RootReduxState) => state.area.area);
  const totalListings = useSelector((state: RootReduxState) => state.listings.totalListings);
  const searchSlug = useSelector((state: RootReduxState) => state.DEPRECATED_filter.searchSlug);
  const isHouse = useSelector(
    (state: RootReduxState) =>
      state.DEPRECATED_filter.propertyTypes.length === 1 && state.DEPRECATED_filter.propertyTypes[0] === 'house',
  );

  const { name, resourceId, type } = area;
  const formattedNumberOfListings = totalListings.toLocaleString('en-US', { minimumFractionDigits: 0 });
  const houseOrApartment = isHouse ? 'house' : 'apartment';

  const [dynamicBlurb] = useDynamicBlurb({
    areaType: type,
    areaName: name,
    numberOfListings: formattedNumberOfListings,
    houseOrApartment,
  });

  const [blurbLinks] = useBlurbLinks({
    name,
    areaType: type,
    resourceId,
    searchSlug,
    houseOrApartment,
  });

  return [dynamicBlurb, blurbLinks, houseOrApartment];
};
